import React from "react";
import { Music2, ShieldCheck, Sparkles, Download } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { PURCHASE_STEPS } from "@/constants/testIds";

// Compact reassurance strip shown on the Wizard (composing) and Checkout (payment) pages -
// deliberately small/non-blocking so it never interferes with the actual form/payment flow,
// it just sits alongside it as a trust anchor.
export default function PurchaseStepsReassurance() {
  const { t } = useI18n();
  const steps = [
    { icon: Music2, title: t("purchaseSteps.step1Title"), desc: t("purchaseSteps.step1Desc") },
    { icon: ShieldCheck, title: t("purchaseSteps.step2Title"), desc: t("purchaseSteps.step2Desc") },
    { icon: Sparkles, title: t("purchaseSteps.step3Title"), desc: t("purchaseSteps.step3Desc") },
  ];

  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid={PURCHASE_STEPS.container}>
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{t("purchaseSteps.title")}</p>
      <div className="mt-4 space-y-4">
        {steps.map((step, i) => (
          <div key={step.title} className="flex items-start gap-3" data-testid={PURCHASE_STEPS.step(i + 1)}>
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <step.icon className="h-4 w-4" strokeWidth={1.75} />
            </div>
            <div>
              <p className="text-sm font-medium leading-tight">{step.title}</p>
              <p className="mt-0.5 text-xs leading-snug text-muted-foreground">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-1.5 border-t border-border pt-3 text-xs font-medium text-primary">
        <Download className="h-3.5 w-3.5" />
        {t("purchaseSteps.bonus")}
      </div>
    </div>
  );
}
